import { Api } from 'api';
import { callApi } from 'root/appSaga';
import { all, put, takeEvery } from 'redux-saga/effects';
import { PROPOSED_DB_ACTION_TYPE } from 'myParkdUtils/enums';
import { sleep } from 'myParkdUtils/utils';
import * as importVehiclesActions from 'features/vehicles/importVehiclesActions';
import { GAAction, GACategory, trackDataLayerEvent } from 'myParkdUtils/googleAnalytics';
import { TELEMATIC_TYPE_APP } from '../../myParkdUtils/constants';


export function* importVehiclesSaga() {
    return yield all([
        takeEvery(importVehiclesActions.VALIDATE_ENTERED_LICENSE_PLATES_START, validateEnteredLicensePlates),
        takeEvery(importVehiclesActions.IMPORT_VALID_LICENSE_PLATES_START, importValidLicensePlates),
    ]);
}

export function* validateEnteredLicensePlates(params) {
    try {
        const telematicAccountType = params.payload.telematicAccountType;
        const licensePlates = params.payload.licensePlates;
        const validationResult = yield callApi(Api.validateEnteredLicensePlates, telematicAccountType, licensePlates);
        yield put(importVehiclesActions.validateEnteredLicensePlatesCompleted(validationResult));
        trackDataLayerEvent({ event: GAAction.VALIDATE_LICENSE_PLATES });
    } catch (error) {
        yield put(importVehiclesActions.validateEnteredLicensePlatesError(error));
    }
}

export function* importValidLicensePlates(params) {
    try {
        const telematicAccountType = params.payload.telematicAccountType;
        const fullyValid = params.payload.fullyValid;
        let proposedDbActions = params.payload.proposedDbActions;
        if (telematicAccountType === TELEMATIC_TYPE_APP) {
            proposedDbActions = proposedDbActions.filter((dbAction) => dbAction.type === PROPOSED_DB_ACTION_TYPE.ADD);
        }
        yield callApi(Api.importValidLicensePlates, telematicAccountType, proposedDbActions);
        if (!fullyValid) {
            yield sleep(1000); // ux: show import spinner when clicking import button manually (as rerouting feels too fast)
        }
        yield put(importVehiclesActions.importValidLicensePlatesCompleted());
        trackDataLayerEvent({ event: GAAction.IMPORT_LICENSE_PLATES });
    } catch (error) {
        yield put(importVehiclesActions.importValidLicensePlatesError(error));
    }
}
